/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const DATA_RIGHT_CHART = "dataRightChart";
const CRITICAL_JOBS_DATA = "criticalJobsData";
const CURRENT_PLAN_DATES = "currentPlanDates";
const CENTER_GRAPH = "centerGraph";
const KPI = "kpi";

module.exports = {
    CRITICAL_JOBS_DATA,
    CURRENT_PLAN_DATES,
    DATA_RIGHT_CHART,
    CENTER_GRAPH,
    KPI,
}